import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Badge } from 'react-bootstrap-5';

type OfficeBadgeProps = {
  officeName: string;
  onClick: () => void;
};

const OfficeBadge = ({ officeName, onClick } : OfficeBadgeProps) => {
  return (
    <Badge
      bg="muted"
      className="clickable px-3 py-2 d-flex gap-3 align-items-center"
      onClick={onClick}
    >
      <div>
        {officeName}
      </div>
      <FontAwesomeIcon icon={faClose} />
    </Badge>
  );
};

export default OfficeBadge;
